export const translations = {
  fr: {
    // Header
    services: "Nos Services",
    fleet: "Notre Flotte",
    about: "À Propos",
    contact: "Contact",
    bookNow: "Réserver Maintenant",
    
    // Hero Section
    heroTitle: "LUXOR LIMOUSINE",
    heroSubtitle: "SERVICE PREMIUM",
    heroDescription: "Votre service de transport haut de gamme à Montreux",
    heroTagline: "Dédié. Professionnel. Personnel.",
    heroText: "Votre service de limousine premium dans le canton de Vaud et toute la Suisse",
    requestQuote: "DEMANDER UN DEVIS",
    
    // Services Section
    whatWeDo: "CE QUE NOUS FAISONS",
    servicesTitle: "SERVICE LIMOUSINE, TRANSFERTS AÉROPORT,\nNAVETTES ÉVÉNEMENTS - TOUT LE RESTE?",
    servicesDescription: "Avec plus de 15 ans d'expérience, nous offrons des services de chauffeur de première classe sur mesure à Montreux, dans tout le canton de Vaud et en Suisse.",
    
    airportTransfers: "TRANSFERTS AÉROPORT",
    airportDescription: "Service de transfert ponctuel et confortable vers tous les aéroports suisses et internationaux",
    
    limousineService: "SERVICE LIMOUSINE",
    limousineDescription: "Transport VIP avec chauffeur professionnel pour vos déplacements d'affaires et privés",
    
    eventsService: "ÉVÉNEMENTS & PLUS",
    eventsDescription: "Service multi-fonctionnel pour mariages, galas, excursions et transport scolaire sécurisé",
    
    available247: "24/7 Disponible",
    available247Description: "Service disponible jour et nuit, 7 jours sur 7 pour tous vos besoins",
    
    expertDrivers: "Chauffeurs Experts",
    expertDriversDescription: "Chauffeurs professionnels, multilingues et parfaitement discrets",
    
    allSwitzerland: "Toute la Suisse",
    allSwitzerlandDescription: "Genève, Lausanne, Zurich, Gstaad, stations de ski et plus encore",
    
    learnMore: "En savoir plus",
    
    // Fleet Section
    fleetTitle: "NOTRE FLOTTE PREMIUM",
    fleetDescription: "Une flotte diversifiée de véhicules haut de gamme pour répondre à tous vos besoins de transport, du taxi standard à l'autocar de luxe.",
    
    prestige: "PRESTIGE",
    comfort: "CONFORT",
    group: "GROUPE",
    economy: "ÉCONOMIQUE",
    events: "ÉVÉNEMENTS",
    largeGroups: "GRANDS GROUPES",
    
    mercedesS: "Mercedes Classe S",
    mercedesSDescription: "Le summum du luxe et du confort pour vos déplacements les plus prestigieux",
    
    mercedesE: "Mercedes Classe E",
    mercedesEDescription: "Élégance et performance pour vos déplacements d'affaires et privés",
    
    mercedesV: "Mercedes Classe V",
    mercedesVDescription: "Véhicule spacieux et confortable pour vos groupes jusqu'à 7 personnes",
    
    standardTaxi: "Taxi Standard",
    standardTaxiDescription: "Solution rapide et économique pour vos trajets quotidiens",
    
    sprinter: "Mercedes Sprinter",
    sprinterDescription: "Minibus premium pour excursions et événements jusqu'à 16 personnes",
    
    luxuryCoach: "Autocar",
    luxuryCoachDescription: "Autocar premium pour grands groupes et voyages organisés",
    
    passengers: "passagers",
    luggage: "bagages",
    upTo: "Jusqu'à",
    from: "À partir de",
    customQuote: "Devis sur mesure",
    
    specialServices: "Services Spéciaux",
    schoolTransport: "Transport Scolaire Sécurisé",
    schoolTransportDescription: "Minibus équipés de sièges enfants homologués et chauffeurs spécialisés pour le transport scolaire en toute sécurité.",
    
    pmrVehicles: "Véhicules Adaptés PMR",
    pmrVehiclesDescription: "Véhicules spécialement équipés pour le transport de personnes à mobilité réduite avec rampes d'accès et équipements adaptés.",
    
    // About Section
    aboutTitle: "À PROPOS DE LUXOR LIMOUSINE",
    aboutDescription1: "est votre partenaire de confiance pour tous vos besoins de transport haut de gamme à Montreux et dans toute la Suisse. Depuis plus de 15 ans, nous offrons un service d'exception alliant",
    aboutDescription2: "élégance, ponctualité et professionnalisme",
    aboutDescription3: "Basés dans le magnifique canton de Vaud, nous desservons les destinations les plus prisées :",
    aboutDescription4: "Genève, Lausanne, Zurich, Gstaad, les stations de ski alpines",
    aboutDescription5: ", ainsi que tous les aéroports suisses et internationaux. Notre équipe de chauffeurs multilingues et notre flotte de véhicules premium vous garantissent une expérience de transport incomparable.",
    
    yearsExperience: "Années d'Expérience",
    serviceAvailable: "Service Disponible",
    satisfiedClients: "Clients Satisfaits",
    destinations: "Destinations",
    
    securityConfidentiality: "Sécurité & Confidentialité",
    securityDescription: "Nos chauffeurs professionnels garantissent votre sécurité et respectent votre confidentialité avec la plus grande discrétion.",
    
    personalizedService: "Service Personnalisé",
    personalizedDescription: "Chaque trajet est adapté à vos besoins spécifiques. Notre équipe multilingue est à votre écoute 24h/24.",
    
    excellencePunctuality: "Excellence & Ponctualité",
    excellenceDescription: "Nous nous engageons à vous offrir un service d'exception avec une ponctualité irréprochable pour tous vos déplacements.",
    
    mainDestinations: "Nos Destinations Principales",
    airports: "Aéroports",
    cities: "Villes",
    skiResorts: "Stations de Ski",
    eventsDestinations: "Événements",
    
    // Contact Section
    bookTransport: "RÉSERVEZ VOTRE TRANSPORT",
    contactDescription: "Contactez-nous dès maintenant pour réserver votre service de transport premium. Notre équipe est disponible 24h/24 et 7j/7 pour répondre à tous vos besoins.",
    
    quoteRequest: "Demande de Devis",
    fullName: "Nom complet",
    phone: "Téléphone",
    email: "Email",
    desiredService: "Service souhaité",
    desiredDate: "Date souhaitée",
    message: "Message",
    messagePlaceholder: "Détails de votre demande (destination, nombre de passagers, besoins spécifiques...)",
    
    chooseService: "Choisir un service",
    sendRequest: "Envoyer ma demande",
    
    immediateBooking: "Réservation Immédiate",
    address: "Adresse",
    hours: "Horaires",
    officeHours: "Bureau: Lun-Ven 8h-18h",
    guaranteedResponse: "Réponse Garantie",
    responseTime: "Nous nous engageons à répondre à toutes les demandes dans un délai de",
    maxHours: "2 heures maximum",
    
    // Footer
    companyDescription: "Votre service de transport haut de gamme à Montreux depuis plus de 12 ans. Excellence, ponctualité et discrétion pour tous vos déplacements en Suisse et à l'étranger.",
    followUs: "Suivez-nous:",
    certified: "Certifié Swiss Quality • Assurance Complète",
    license: "Licence Transport Professionnel CH",
    allRightsReserved: "Tous droits réservés.",
    legalNotices: "Mentions Légales",
    privacyPolicy: "Politique de Confidentialité",
    termsConditions: "Conditions Générales",
    
    // Toast Messages
    requestSent: "Demande envoyée!",
    responseMessage: "Nous vous contacterons sous 24 heures. Merci de votre confiance.",
    
    // Languages
    language: "Langue"
  },
  
  en: {
    // Header
    services: "Our Services",
    fleet: "Our Fleet",
    about: "About Us",
    contact: "Contact",
    bookNow: "Book Now",
    
    // Hero Section
    heroTitle: "LUXOR LIMOUSINE",
    heroSubtitle: "PREMIUM SERVICE",
    heroDescription: "Your premium transport service in Montreux",
    heroTagline: "Dedicated. Professional. Personal.",
    heroText: "Your premium limousine service in the Canton of Vaud and throughout Switzerland",
    requestQuote: "REQUEST A QUOTE",
    
    // Services Section
    whatWeDo: "WHAT WE DO",
    servicesTitle: "LIMOUSINE SERVICE, AIRPORT TRANSFERS,\nEVENT SHUTTLES - ANYTHING ELSE?",
    servicesDescription: "With over 15 years of experience, we deliver first-class bespoke chauffeur services in Montreux, throughout the Canton of Vaud and Switzerland.",
    
    airportTransfers: "AIRPORT TRANSFERS",
    airportDescription: "Punctual and comfortable transfer service to all Swiss and international airports",
    
    limousineService: "LIMOUSINE SERVICE",
    limousineDescription: "VIP transport with professional chauffeur for your business and private travels",
    
    eventsService: "EVENTS & MORE",
    eventsDescription: "Multi-functional service for weddings, galas, excursions and safe school transport",
    
    available247: "24/7 Available",
    available247Description: "Service available day and night, 7 days a week for all your needs",
    
    expertDrivers: "Expert Drivers",
    expertDriversDescription: "Professional, multilingual and perfectly discreet chauffeurs",
    
    allSwitzerland: "All Switzerland",
    allSwitzerlandDescription: "Geneva, Lausanne, Zurich, Gstaad, ski resorts and more",
    
    learnMore: "Learn more",
    
    // Fleet Section
    fleetTitle: "OUR PREMIUM FLEET",
    fleetDescription: "A diverse fleet of premium vehicles to meet all your transport needs, from standard taxi to luxury coach.",
    
    prestige: "PRESTIGE",
    comfort: "COMFORT",
    group: "GROUP",
    economy: "ECONOMY",
    events: "EVENTS",
    largeGroups: "LARGE GROUPS",
    
    mercedesS: "Mercedes S-Class",
    mercedesSDescription: "The ultimate in luxury and comfort for your most prestigious travels",
    
    mercedesE: "Mercedes E-Class",
    mercedesEDescription: "Elegance and performance for your business and private travels",
    
    mercedesV: "Mercedes V-Class",
    mercedesVDescription: "Spacious and comfortable vehicle for groups up to 7 people",
    
    standardTaxi: "Standard Taxi",
    standardTaxiDescription: "Quick and economical solution for your daily trips",
    
    sprinter: "Mercedes Sprinter",
    sprinterDescription: "Premium minibus for excursions and events up to 16 people",
    
    luxuryCoach: "Coach",
    luxuryCoachDescription: "Premium coach for large groups and organized trips",
    
    passengers: "passengers",
    luggage: "luggage",
    upTo: "Up to",
    from: "From",
    customQuote: "Custom quote",
    
    specialServices: "Special Services",
    schoolTransport: "Safe School Transport",
    schoolTransportDescription: "Minibuses equipped with approved child seats and specialized drivers for safe school transport.",
    
    pmrVehicles: "Adapted PMR Vehicles",
    pmrVehiclesDescription: "Specially equipped vehicles for transporting people with reduced mobility with access ramps and adapted equipment.",
    
    // About Section
    aboutTitle: "ABOUT LUXOR LIMOUSINE",
    aboutDescription1: "is your trusted partner for all your premium transport needs in Montreux and throughout Switzerland. For over 15 years, we have been offering exceptional service combining",
    aboutDescription2: "elegance, punctuality and professionalism",
    aboutDescription3: "Based in the beautiful Canton of Vaud, we serve the most sought-after destinations:",
    aboutDescription4: "Geneva, Lausanne, Zurich, Gstaad, Alpine ski resorts",
    aboutDescription5: ", as well as all Swiss and international airports. Our team of multilingual chauffeurs and our fleet of premium vehicles guarantee you an incomparable transport experience.",
    
    yearsExperience: "Years of Experience",
    serviceAvailable: "Service Available",
    satisfiedClients: "Satisfied Clients",
    destinations: "Destinations",
    
    securityConfidentiality: "Security & Confidentiality",
    securityDescription: "Our professional chauffeurs guarantee your safety and respect your confidentiality with the utmost discretion.",
    
    personalizedService: "Personalized Service",
    personalizedDescription: "Each trip is adapted to your specific needs. Our multilingual team is at your service 24/7.",
    
    excellencePunctuality: "Excellence & Punctuality",
    excellenceDescription: "We are committed to offering you exceptional service with impeccable punctuality for all your travels.",
    
    mainDestinations: "Our Main Destinations",
    airports: "Airports",
    cities: "Cities",
    skiResorts: "Ski Resorts",
    eventsDestinations: "Events",
    
    // Contact Section
    bookTransport: "BOOK YOUR TRANSPORT",
    contactDescription: "Contact us now to book your premium transport service. Our team is available 24/7 to meet all your needs.",
    
    quoteRequest: "Quote Request",
    fullName: "Full Name",
    phone: "Phone",
    email: "Email",
    desiredService: "Desired Service",
    desiredDate: "Desired Date",
    message: "Message",
    messagePlaceholder: "Details of your request (destination, number of passengers, specific needs...)",
    
    chooseService: "Choose a service",
    sendRequest: "Send my request",
    
    immediateBooking: "Immediate Booking",
    address: "Address",
    hours: "Hours",
    officeHours: "Office: Mon-Fri 8am-6pm",
    guaranteedResponse: "Guaranteed Response",
    responseTime: "We are committed to responding to all requests within",
    maxHours: "2 hours maximum",
    
    // Footer
    companyDescription: "Your premium transport service in Montreux for over 15 years. Excellence, punctuality and discretion for all your travels in Switzerland.",
    followUs: "Follow us:",
    certified: "Swiss Quality Certified • Full Insurance",
    license: "Professional Transport License CH",
    allRightsReserved: "All rights reserved.",
    legalNotices: "Legal Notices",
    privacyPolicy: "Privacy Policy",
    termsConditions: "Terms & Conditions",
    
    // Toast Messages
    requestSent: "Request sent!",
    responseMessage: "We will contact you within 24 hours. Thank you for your trust.",
    
    // Languages
    language: "Language"
  },
  
  de: {
    // Header
    services: "Unsere Dienste",
    fleet: "Unsere Flotte",
    about: "Über Uns",
    contact: "Kontakt",
    bookNow: "Jetzt Buchen",
    
    // Hero Section
    heroTitle: "LUXOR LIMOUSINE",
    heroSubtitle: "PREMIUM SERVICE",
    heroDescription: "Ihr Premium-Transportservice in Montreux",
    heroTagline: "Engagiert. Professionell. Persönlich.",
    heroText: "Ihr Premium-Limousinenservice im Kanton Waadt und in der ganzen Schweiz",
    requestQuote: "ANGEBOT ANFORDERN",
    
    // Services Section
    whatWeDo: "WAS WIR TUN",
    servicesTitle: "LIMOUSINENSERVICE, FLUGHAFENTRANSFERS,\nEVENT-SHUTTLES - NOCH ETWAS ANDERES?",
    servicesDescription: "Mit über 15 Jahren Erfahrung bieten wir erstklassige, maßgeschneiderte Chauffeursdienste in Montreux, im gesamten Kanton Waadt und in der Schweiz.",
    
    airportTransfers: "FLUGHAFENTRANSFERS",
    airportDescription: "Pünktlicher und komfortabler Transferservice zu allen schweizerischen und internationalen Flughäfen",
    
    limousineService: "LIMOUSINENSERVICE",
    limousineDescription: "VIP-Transport mit professionellem Chauffeur für Ihre Geschäfts- und Privatreisen",
    
    eventsService: "EVENTS & MEHR",
    eventsDescription: "Multifunktionaler Service für Hochzeiten, Galas, Ausflüge und sicheren Schultransport",
    
    available247: "24/7 Verfügbar",
    available247Description: "Service rund um die Uhr verfügbar, 7 Tage die Woche für alle Ihre Bedürfnisse",
    
    expertDrivers: "Fachkundige Fahrer",
    expertDriversDescription: "Professionelle, mehrsprachige und absolut diskrete Chauffeure",
    
    allSwitzerland: "Ganze Schweiz",
    allSwitzerlandDescription: "Genf, Lausanne, Zürich, Gstaad, Skigebiete und mehr",
    
    learnMore: "Mehr erfahren",
    
    // Fleet Section
    fleetTitle: "UNSERE PREMIUM-FLOTTE",
    fleetDescription: "Eine vielfältige Flotte von Premium-Fahrzeugen für alle Ihre Transportbedürfnisse, vom Standard-Taxi bis zum Luxusbus.",
    
    prestige: "PRESTIGE",
    comfort: "KOMFORT",
    group: "GRUPPE",
    economy: "WIRTSCHAFT",
    events: "EVENTS",
    largeGroups: "GROSSE GRUPPEN",
    
    mercedesS: "Mercedes S-Klasse",
    mercedesSDescription: "Das Höchste an Luxus und Komfort für Ihre prestigeträchtigsten Reisen",
    
    mercedesE: "Mercedes E-Klasse",
    mercedesEDescription: "Eleganz und Leistung für Ihre Geschäfts- und Privatreisen",
    
    mercedesV: "Mercedes V-Klasse",
    mercedesVDescription: "Geräumiges und komfortables Fahrzeug für Gruppen bis zu 7 Personen",
    
    standardTaxi: "Standard-Taxi",
    standardTaxiDescription: "Schnelle und wirtschaftliche Lösung für Ihre täglichen Fahrten",
    
    sprinter: "Mercedes Sprinter",
    sprinterDescription: "Premium-Kleinbus für Ausflüge und Events bis zu 16 Personen",
    
    luxuryCoach: "Bus",
    luxuryCoachDescription: "Premium-Bus für große Gruppen und organisierte Reisen",
    
    passengers: "Passagiere",
    luggage: "Gepäck",
    upTo: "Bis zu",
    from: "Ab",
    customQuote: "Individuelles Angebot",
    
    specialServices: "Spezielle Dienstleistungen",
    schoolTransport: "Sicherer Schultransport",
    schoolTransportDescription: "Kleinbusse mit zugelassenen Kindersitzen und spezialisierten Fahrern für sicheren Schultransport.",
    
    pmrVehicles: "Angepasste PMR-Fahrzeuge",
    pmrVehiclesDescription: "Speziell ausgestattete Fahrzeuge für den Transport von Menschen mit eingeschränkter Mobilität mit Zugangsrampen und angepasster Ausstattung.",
    
    // About Section
    aboutTitle: "ÜBER LUXOR LIMOUSINE",
    aboutDescription1: "ist Ihr vertrauensvoller Partner für alle Ihre Premium-Transportbedürfnisse in Montreux und in der ganzen Schweiz. Seit über 15 Jahren bieten wir außergewöhnlichen Service, der",
    aboutDescription2: "Eleganz, Pünktlichkeit und Professionalität",
    aboutDescription3: "verbindet. Mit Sitz im schönen Kanton Waadt bedienen wir die begehrtesten Destinationen:",
    aboutDescription4: "Genf, Lausanne, Zürich, Gstaad, alpine Skigebiete",
    aboutDescription5: ", sowie alle schweizerischen und internationalen Flughäfen. Unser Team mehrsprachiger Chauffeure und unsere Flotte von Premium-Fahrzeugen garantieren Ihnen ein unvergleichliches Transporterlebnis.",
    
    yearsExperience: "Jahre Erfahrung",
    serviceAvailable: "Service Verfügbar",
    satisfiedClients: "Zufriedene Kunden",
    destinations: "Destinationen",
    
    securityConfidentiality: "Sicherheit & Vertraulichkeit",
    securityDescription: "Unsere professionellen Chauffeure gewährleisten Ihre Sicherheit und respektieren Ihre Vertraulichkeit mit größter Diskretion.",
    
    personalizedService: "Personalisierter Service",
    personalizedDescription: "Jede Fahrt wird an Ihre spezifischen Bedürfnisse angepasst. Unser mehrsprachiges Team steht Ihnen 24/7 zur Verfügung.",
    
    excellencePunctuality: "Exzellenz & Pünktlichkeit",
    excellenceDescription: "Wir verpflichten uns, Ihnen außergewöhnlichen Service mit tadelloser Pünktlichkeit für alle Ihre Reisen zu bieten.",
    
    mainDestinations: "Unsere Hauptdestinationen",
    airports: "Flughäfen",
    cities: "Städte",
    skiResorts: "Skigebiete",
    eventsDestinations: "Events",
    
    // Contact Section
    bookTransport: "BUCHEN SIE IHREN TRANSPORT",
    contactDescription: "Kontaktieren Sie uns jetzt, um Ihren Premium-Transportservice zu buchen. Unser Team steht Ihnen 24/7 zur Verfügung, um alle Ihre Bedürfnisse zu erfüllen.",
    
    quoteRequest: "Angebotsanfrage",
    fullName: "Vollständiger Name",
    phone: "Telefon",
    email: "E-Mail",
    desiredService: "Gewünschter Service",
    desiredDate: "Gewünschtes Datum",
    message: "Nachricht",
    messagePlaceholder: "Details Ihrer Anfrage (Ziel, Anzahl Passagiere, spezielle Bedürfnisse...)",
    
    chooseService: "Service wählen",
    sendRequest: "Anfrage senden",
    
    immediateBooking: "Sofortige Buchung",
    address: "Adresse",
    hours: "Öffnungszeiten",
    officeHours: "Büro: Mo-Fr 8-18 Uhr",
    guaranteedResponse: "Garantierte Antwort",
    responseTime: "Wir verpflichten uns, auf alle Anfragen innerhalb von",
    maxHours: "maximal 2 Stunden",
    
    // Footer
    companyDescription: "Ihr Premium-Transportservice in Montreux seit über 15 Jahren. Exzellenz, Pünktlichkeit und Diskretion für alle Ihre Reisen in der Schweiz.",
    followUs: "Folgen Sie uns:",
    certified: "Swiss Quality Zertifiziert • Vollversicherung",
    license: "Professionelle Transportlizenz CH",
    allRightsReserved: "Alle Rechte vorbehalten.",
    legalNotices: "Rechtliche Hinweise",
    privacyPolicy: "Datenschutzrichtlinie",
    termsConditions: "Allgemeine Geschäftsbedingungen",
    
    // Toast Messages
    requestSent: "Anfrage gesendet!",
    responseMessage: "Wir werden Sie innerhalb von 24 Stunden kontaktieren. Vielen Dank für Ihr Vertrauen.",
    
    // Languages
    language: "Sprache"
  },
  
  it: {
    // Header
    services: "I Nostri Servizi",
    fleet: "La Nostra Flotta",
    about: "Chi Siamo",
    contact: "Contatto",
    bookNow: "Prenota Ora",
    
    // Hero Section
    heroTitle: "LUXOR LIMOUSINE",
    heroSubtitle: "SERVIZIO PREMIUM",
    heroDescription: "Il vostro servizio di trasporto premium a Montreux",
    heroTagline: "Dedicato. Professionale. Personale.",
    heroText: "Il vostro servizio limousine premium nel Cantone di Vaud e in tutta la Svizzera",
    requestQuote: "RICHIEDI UN PREVENTIVO",
    
    // Services Section
    whatWeDo: "COSA FACCIAMO",
    servicesTitle: "SERVIZIO LIMOUSINE, TRASFERIMENTI AEROPORTO,\nNAVETTE EVENTI - QUALCOS'ALTRO?",
    servicesDescription: "Con oltre 15 anni di esperienza, offriamo servizi di autista di prima classe su misura a Montreux, in tutto il Cantone di Vaud e in Svizzera.",
    
    airportTransfers: "TRASFERIMENTI AEROPORTO",
    airportDescription: "Servizio di trasferimento puntuale e confortevole verso tutti gli aeroporti svizzeri e internazionali",
    
    limousineService: "SERVIZIO LIMOUSINE",
    limousineDescription: "Trasporto VIP con autista professionale per i vostri spostamenti business e privati",
    
    eventsService: "EVENTI E ALTRO",
    eventsDescription: "Servizio multifunzionale per matrimoni, gala, escursioni e trasporto scolastico sicuro",
    
    available247: "Disponibile 24/7",
    available247Description: "Servizio disponibile giorno e notte, 7 giorni su 7 per tutte le vostre esigenze",
    
    expertDrivers: "Autisti Esperti",
    expertDriversDescription: "Autisti professionali, multilingue e perfettamente discreti",
    
    allSwitzerland: "Tutta la Svizzera",
    allSwitzerlandDescription: "Ginevra, Losanna, Zurigo, Gstaad, stazioni sciistiche e altro",
    
    learnMore: "Scopri di più",
    
    // Fleet Section
    fleetTitle: "LA NOSTRA FLOTTA PREMIUM",
    fleetDescription: "Una flotta diversificata di veicoli premium per soddisfare tutte le vostre esigenze di trasporto, dal taxi standard al pullman di lusso.",
    
    prestige: "PRESTIGIO",
    comfort: "COMFORT",
    group: "GRUPPO",
    economy: "ECONOMICO",
    events: "EVENTI",
    largeGroups: "GRANDI GRUPPI",
    
    mercedesS: "Mercedes Classe S",
    mercedesSDescription: "Il massimo del lusso e del comfort per i vostri viaggi più prestigiosi",
    
    mercedesE: "Mercedes Classe E",
    mercedesEDescription: "Eleganza e prestazioni per i vostri viaggi business e privati",
    
    mercedesV: "Mercedes Classe V",
    mercedesVDescription: "Veicolo spazioso e confortevole per gruppi fino a 7 persone",
    
    standardTaxi: "Taxi Standard",
    standardTaxiDescription: "Soluzione rapida ed economica per i vostri spostamenti quotidiani",
    
    sprinter: "Mercedes Sprinter",
    sprinterDescription: "Minibus premium per escursioni ed eventi fino a 16 persone",
    
    luxuryCoach: "Pullman",
    luxuryCoachDescription: "Pullman premium per grandi gruppi e viaggi organizzati",
    
    passengers: "passeggeri",
    luggage: "bagagli",
    upTo: "Fino a",
    from: "A partire da",
    customQuote: "Preventivo personalizzato",
    
    specialServices: "Servizi Speciali",
    schoolTransport: "Trasporto Scolastico Sicuro",
    schoolTransportDescription: "Minibus equipaggiati con seggiolini per bambini omologati e autisti specializzati per il trasporto scolastico in sicurezza.",
    
    pmrVehicles: "Veicoli Adattati PMR",
    pmrVehiclesDescription: "Veicoli appositamente attrezzati per il trasporto di persone con mobilità ridotta con rampe di accesso e attrezzature adatte.",
    
    // About Section
    aboutTitle: "CHI È LUXOR LIMOUSINE",
    aboutDescription1: "è il vostro partner di fiducia per tutte le vostre esigenze di trasporto premium a Montreux e in tutta la Svizzera. Da oltre 15 anni offriamo un servizio eccezionale che unisce",
    aboutDescription2: "eleganza, puntualità e professionalità",
    aboutDescription3: "Con sede nel bellissimo Cantone di Vaud, serviamo le destinazioni più ambite:",
    aboutDescription4: "Ginevra, Losanna, Zurigo, Gstaad, stazioni sciistiche alpine",
    aboutDescription5: ", così come tutti gli aeroporti svizzeri e internazionali. Il nostro team di autisti multilingue e la nostra flotta di veicoli premium vi garantiscono un'esperienza di trasporto incomparabile.",
    
    yearsExperience: "Anni di Esperienza",
    serviceAvailable: "Servizio Disponibile",
    satisfiedClients: "Clienti Soddisfatti",
    destinations: "Destinazioni",
    
    securityConfidentiality: "Sicurezza e Riservatezza",
    securityDescription: "I nostri autisti professionali garantiscono la vostra sicurezza e rispettano la vostra riservatezza con la massima discrezione.",
    
    personalizedService: "Servizio Personalizzato",
    personalizedDescription: "Ogni viaggio è adattato alle vostre esigenze specifiche. Il nostro team multilingue è a vostra disposizione 24/7.",
    
    excellencePunctuality: "Eccellenza e Puntualità",
    excellenceDescription: "Ci impegniamo a offrirvi un servizio eccezionale con una puntualità impeccabile per tutti i vostri spostamenti.",
    
    mainDestinations: "Le Nostre Destinazioni Principali",
    airports: "Aeroporti",
    cities: "Città",
    skiResorts: "Stazioni Sciistiche",
    eventsDestinations: "Eventi",
    
    // Contact Section
    bookTransport: "PRENOTATE IL VOSTRO TRASPORTO",
    contactDescription: "Contattateci subito per prenotare il vostro servizio di trasporto premium. Il nostro team è disponibile 24/7 per soddisfare tutte le vostre esigenze.",
    
    quoteRequest: "Richiesta Preventivo",
    fullName: "Nome Completo",
    phone: "Telefono",
    email: "Email",
    desiredService: "Servizio Desiderato",
    desiredDate: "Data Desiderata",
    message: "Messaggio",
    messagePlaceholder: "Dettagli della vostra richiesta (destinazione, numero di passeggeri, esigenze specifiche...)",
    
    chooseService: "Scegli un servizio",
    sendRequest: "Invia richiesta",
    
    immediateBooking: "Prenotazione Immediata",
    address: "Indirizzo",
    hours: "Orari",
    officeHours: "Ufficio: Lun-Ven 8-18",
    guaranteedResponse: "Risposta Garantita",
    responseTime: "Ci impegniamo a rispondere a tutte le richieste entro",
    maxHours: "massimo 2 ore",
    
    // Footer
    companyDescription: "Il vostro servizio di trasporto premium a Montreux da oltre 15 anni. Eccellenza, puntualità e discrezione per tutti i vostri spostamenti in Svizzera.",
    followUs: "Seguiteci:",
    certified: "Certificato Swiss Quality • Assicurazione Completa",
    license: "Licenza Trasporto Professionale CH",
    allRightsReserved: "Tutti i diritti riservati.",
    legalNotices: "Note Legali",
    privacyPolicy: "Politica Privacy",
    termsConditions: "Termini e Condizioni",
    
    // Toast Messages
    requestSent: "Richiesta inviata!",
    responseMessage: "Vi contatteremo entro 24 ore. Grazie per la fiducia.",
    
    // Languages
    language: "Lingua"
  },
  
  sr: {
    // Header
    services: "Наши Сервиси",
    fleet: "Наша Флота",
    about: "О Нама",
    contact: "Контакт",
    bookNow: "Резервиши Сада",
    
    // Hero Section
    heroTitle: "LUXOR LIMOUSINE",
    heroSubtitle: "ПРЕМИЈУМ СЕРВИС",
    heroDescription: "Ваш премијум транспортни сервис у Монтреу",
    heroTagline: "Посвећено. Професионално. Лично.",
    heroText: "Ваш премијум лимузински сервис у кантону Во и широм Швајцарске",
    requestQuote: "ЗАТРАЖИ ПОНУДУ",
    
    // Services Section
    whatWeDo: "ШТА РАДИМО",
    servicesTitle: "ЛИМУЗИНСКИ СЕРВИС, ТРАНСФЕР ДО АЕРОДРОМА,\nШАТЛ ЗА ДОГАЂАЈЕ - НЕШТО ДРУГО?",
    servicesDescription: "Са више од 15 година искуства, пружамо прворазредне услуге шофера по мери у Монтреу, широм кантона Во и Швајцарске.",
    
    airportTransfers: "ТРАНСФЕР ДО АЕРОДРОМА",
    airportDescription: "Тачан и удобан транспорт до свих швајцарских и међународних аеродрома",
    
    limousineService: "ЛИМУЗИНСКИ СЕРВИС",
    limousineDescription: "VIP транспорт са професионалним шофером за ваша пословна и приватна путовања",
    
    eventsService: "ДОГАЂАЈИ И ВИШЕ",
    eventsDescription: "Мултифункционални сервис за венчања, гала догађаје, излете и безбедан превоз ученика",
    
    available247: "Доступно 24/7",
    available247Description: "Сервис доступан дан и ноћ, 7 дана у недељи за све ваше потребе",
    
    expertDrivers: "Стручни Шофери",
    expertDriversDescription: "Професионални, вишејезични и потпуно дискретни шофери",
    
    allSwitzerland: "Цела Швајцарска",
    allSwitzerlandDescription: "Женева, Лозана, Цирих, Гштад, ски центри и више",
    
    learnMore: "Сазнај више",
    
    // Fleet Section
    fleetTitle: "НАША ПРЕМИЈУМ ФЛОТА",
    fleetDescription: "Разноврсна флота премијум возила која задовољавају све ваше транспортне потребе, од стандардног таксија до луксузног аутобуса.",
    
    prestige: "ПРЕСТИЖ",
    comfort: "КОМФОР",
    group: "ГРУПА",
    economy: "ЕКОНОМИЧНО",
    events: "ДОГАЂАЈИ",
    largeGroups: "ВЕЛИКЕ ГРУПЕ",
    
    mercedesS: "Mercedes S Класа",
    mercedesSDescription: "Врхунац луксуза и комфора за ваша најпрестижнија путовања",
    
    mercedesE: "Mercedes E Класа",
    mercedesEDescription: "Елеганција и перформансе за ваша пословна и приватна путовања",
    
    mercedesV: "Mercedes V Класа",
    mercedesVDescription: "Простран и удобан возило за групе до 7 особа",
    
    standardTaxi: "Стандардни Такси",
    standardTaxiDescription: "Брзо и економично решење за ваше свакодневне вожње",
    
    sprinter: "Mercedes Sprinter",
    sprinterDescription: "Премијум мини аутобус за излете и догађаје до 16 особа",
    
    luxuryCoach: "Аутобус",
    luxuryCoachDescription: "Премијум аутобус за велике групе и организована путовања",
    
    passengers: "путници",
    luggage: "пртљаг",
    upTo: "До",
    from: "Од",
    customQuote: "Индивидуална понуда",
    
    specialServices: "Посебни Сервиси",
    schoolTransport: "Безбедан Школски Транспорт",
    schoolTransportDescription: "Мини аутобуси опремљени одобреним дечјим седиштима и специјализованим возачима за безбедан школски транспорт.",
    
    pmrVehicles: "Прилагођена ПМР Возила",
    pmrVehiclesDescription: "Специјално опремљена возила за превоз особа са смањеном покретљивошћу са рампама за приступ и прилагођеном опремом.",
    
    // About Section
    aboutTitle: "О LUXOR LIMOUSINE",
    aboutDescription1: "је ваш поуздан партнер за све ваше премијум транспортне потребе у Монтреу и широм Швајцарске. Више од 15 година пружамо изузетан сервис који комбинује",
    aboutDescription2: "елеганцију, тачност и професионализам",
    aboutDescription3: "Са седиштем у прелепом кантону Во, опслужујемо најтраженије дестинације:",
    aboutDescription4: "Женева, Лозана, Цирих, Гштад, алпски ски центри",
    aboutDescription5: ", као и сви швајцарски и међународни аеродроми. Наш тим вишејезичних шофера и наша флота премијум возила гарантују вам неупоредиво транспортно искуство.",
    
    yearsExperience: "Година Искуства",
    serviceAvailable: "Сервис Доступан",
    satisfiedClients: "Задовољни Клијенти",
    destinations: "Дестинације",
    
    securityConfidentiality: "Безбедност и Поверљивост",
    securityDescription: "Наши професионални шофери гарантују вашу безбедност и поштују вашу поверљивост са највећом дискрецијом.",
    
    personalizedService: "Персонализован Сервис",
    personalizedDescription: "Свако путовање је прилагођено вашим специфичним потребама. Наш вишејезични тим вам је на услузи 24/7.",
    
    excellencePunctuality: "Изврсност и Тачност",
    excellenceDescription: "Посвећени смо пружању изузетног сервиса са беспрекорном тачношћу за сва ваша путовања.",
    
    mainDestinations: "Наше Главне Дестинације",
    airports: "Аеродроми",
    cities: "Градови",
    skiResorts: "Ски Центри",
    eventsDestinations: "Догађаји",
    
    // Contact Section
    bookTransport: "РЕЗЕРВИШИТЕ ВАШ ТРАНСПОРТ",
    contactDescription: "Контактирајте нас сада да резервишете ваш премијум транспортни сервис. Наш тим је доступан 24/7 да задовољи све ваше потребе.",
    
    quoteRequest: "Захтев за Понуду",
    fullName: "Пуно Име",
    phone: "Телефон",
    email: "Имејл",
    desiredService: "Жељени Сервис",
    desiredDate: "Жељени Датум",
    message: "Порука",
    messagePlaceholder: "Детаљи вашег захтева (дестинација, број путника, специфичне потребе...)",
    
    chooseService: "Изабери сервис",
    sendRequest: "Пошаљи захтев",
    
    immediateBooking: "Тренутна Резервација",
    address: "Адреса",
    hours: "Радно Време",
    officeHours: "Канцеларија: Пон-Пет 8-18",
    guaranteedResponse: "Гарантован Одговор",
    responseTime: "Обавезујемо се да одговоримо на све захтеве у року од",
    maxHours: "максимално 2 сата",
    
    // Footer
    companyDescription: "Ваш премијум транспортни сервис у Монтреу већ преко 15 година. Изврсност, тачност и дискреција за сва ваша путовања у Швајцарској.",
    followUs: "Пратите нас:",
    certified: "Сертификовано Swiss Quality • Потпуно Осигурање",
    license: "Професионална Транспортна Лиценца CH",
    allRightsReserved: "Сва права задржана.",
    legalNotices: "Правне Напомене",
    privacyPolicy: "Политика Приватности",
    termsConditions: "Услови Коришћења",
    
    // Toast Messages
    requestSent: "Захтев послан!",
    responseMessage: "Контактираћемо вас у року од 24 сата. Хвала на поверењу.",
    
    // Languages
    language: "Језик"
  }
};